import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Tooltip from "App/common/ui/Tooltip";

import { TOOLTIPS } from "consts";
import { POPUPS } from "App/componentsConfig";
import { LayoutContext } from "App/common/hoc/Layout";
import { useHotKeys } from "App/common/hooks/hotKeys";
import { insertItem } from "utils";
import { ReactComponent as CloseIcon } from "assets/images/app_svg/close.svg";

function Popup() {
  const history = useHistory();
  const { lState, lMethods } = useContext(LayoutContext);
  const popupContent = { ...POPUPS[lState.popup.alertName] };
  let note = popupContent.note;
  let body = popupContent.body;
  const params = lState.popup.params;
  let footer = null;

  useEffect(() => {
    history.listen(location => {
      lMethods.closePopup();
    });
  }, [history]);

  if (typeof body === "string" && Object.keys(params).length > 0) {
    for (let key in params.body) {
      body = insertItem(body.split(key), params.body[key], 1).join("");
    }
  }

  if (
    typeof popupContent.footer === "string" &&
    Object.keys(params).length > 0
  ) {
    for (let key in params.footer) {
      popupContent.footer = insertItem(
        popupContent.footer.split(key),
        params.footer[key],
        1
      ).join("");
    }
  }

  if (
    typeof popupContent.title === "string" &&
    Object.keys(params).length > 0
  ) {
    for (let key in params.title) {
      if (!popupContent.title.includes(params.title[key]))
        popupContent.title = insertItem(
          popupContent.title.split(key),
          params.title[key],
          1
        ).join("");
    }
  }

  if (typeof note === "string" && note.length > 0) {
    body += "<br><br><strong>NOTE: </strong>" + note;
  }

  useHotKeys(
    "esc",
    e => {
      e.preventDefault();
      closePopup();
    },
    []
  );
  function closePopup() {
    if (
      !(
        (lState.popup.alertName === "CancelAccountConfirmation" &&
          lState.popup.params.loading) ||
        lState.popup.alertName === "applyPendingCharges"
      )
    ) {
      lMethods.closePopup();
    }
  }

  // open the pending changres popup when the x icon clicked on payment activate popup
  function openChargesPendingPopup() {
    lMethods.openPopup("applyPendingCharges", {
      execute: () => {
        lMethods.closePopup();
      },
      backButton: false
    });
  }

  if (lState.popup.alertName === "CancelAccountConfirmation")
    footer = (
      <React.Fragment>
        <div className="popup_footer__btns">
          <div
            className={
              "common_btn btn_primary confirmatin_account_btn" +
              (popupContent.alertType === "WARN" ? " btn-danger" : "")
            }
            onClick={lState.popup.params.execute}
          >
            {lState.popup.params.loading ? (
              <p className="pass_loader" style={{ display: "block" }}>
                <img
                  src={
                    process.env.REACT_APP_STATIC_URL +
                    "/images/submit_loader.gif"
                  }
                  alt="loader"
                />
              </p>
            ) : (
              <p className="pass_text">{popupContent.type}</p>
            )}
          </div>
          <div
            className={
              "common_btn btn_cancel keep_my_account" +
              (lState.popup.params.loading ? " btn_disable" : "")
            }
            onClick={() =>
              !lState.popup.params.loading ? lMethods.closePopup() : {}
            }
          >
            Keep My Account
          </div>
        </div>
      </React.Fragment>
    );
  else
    footer = (
      <React.Fragment>
        {lState.popup.params.showCancelButton && (
          <div className="slider_btn popup_btn_cancel" onClick={closePopup}>
            Cancel
          </div>
        )}
        {popupContent.footer ? (
          <div className="irpopup_msg">
            <p className="semi_strong">
              {typeof popupContent.footer === "string" ? (
                <p dangerouslySetInnerHTML={{ __html: popupContent.footer }} />
              ) : (
                React.createElement(popupContent.footer)
              )}
            </p>
          </div>
        ) : null}
        {popupContent.leftFooter ? (
          <div
            className={[
              lState.popup.params.disableLeftFooter.remove
                ? "new_folder_disable"
                : "new_folder_btn",
              lState.popup.params.disableLeftFooter.disable ? "btn_disable" : ""
            ].join(" ")}
            onClick={
              lState.popup.params.disableLeftFooter.disable
                ? undefined
                : lState.popup.params.createFolder
            }
          >
            {!lState.popup.params.disableLeftFooter.remove && (
              <p>{popupContent.leftFooter}</p>
            )}
          </div>
        ) : null}

        <div className="popup_footer__btns">
          {popupContent.secondType && (
            <div
              className="slider_btn popup_btn_cancel"
              onClick={
                lState.popup.params.cancel
                  ? lState.popup.params.secondExecute
                  : lMethods.closePopup
              }
            >
              {popupContent.secondType ? popupContent.secondType : "Cancel"}
            </div>
          )}
          <div
            className={`slider_btn ${
              lState.popup.params.disable ? "btn_disable" : "btn_primary"
            } ${popupContent.alertType === "WARN" ? " btn-danger" : ""}`}
            onClick={
              lState.popup.params.loading
                ? null
                : lState.popup.params.disable
                ? null
                : lState.popup.params.execute
            }
          >
            {lState.popup.params.loading ? (
              <p className="pass_loader" style={{ display: "block" }}>
                <img
                  src={
                    process.env.REACT_APP_STATIC_URL +
                    "/images/submit_loader.gif"
                  }
                  alt="loader"
                />
              </p>
            ) : (
              <p className="pass_text">{popupContent.type} </p>
            )}
          </div>
        </div>
      </React.Fragment>
    );

  return (
    <div className="main_popup" style={{ display: "block" }}>
      <div className="main_popup_wrapper">
        <div
          className="main_popup_bg_shadow"
          onClick={
            !(lState.popup.alertName === "applyPendingChargesActivate") &&
            closePopup
          }
        />

        <div className="main_popup__inner">
          <div
            className={[
              "popup_wrap popup_backup_cancel",
              popupContent.popupWrapClass
            ].join(" ")}
          >
            {!(
              (lState.popup.alertName === "CancelAccountConfirmation" &&
                lState.popup.params.loading) ||
              lState.popup.alertName === "applyPendingCharges"
            ) &&
              (lState.popup.alertName === "applyPendingChargesActivate" ? (
                <Tooltip {...TOOLTIPS.popUp.close}>
                  <div
                    className="popup_close svg_close"
                    onClick={openChargesPendingPopup}
                  >
                    <div className="icon">
                      <CloseIcon />
                    </div>
                  </div>
                </Tooltip>
              ) : (
                <Tooltip {...TOOLTIPS.popUp.close}>
                  <div className="popup_close svg_close" onClick={closePopup}>
                    <div className="icon">
                      <CloseIcon />
                    </div>
                  </div>
                </Tooltip>
              ))}

            <div className="popup_header">
              {lState.popup.params.backButton && (
                <Tooltip {...TOOLTIPS.popUp.back}>
                  <div
                    className="back_btn"
                    onClick={lState.popup.params.backButton}
                  >
                    <span className="bck_icon">
                      <span className="svg_wrap">➔</span>
                    </span>
                  </div>
                </Tooltip>
              )}
              <div
                className={`sub_title ${
                  lState.popup.params.backButton ? "marginLeft" : ""
                }`}
              >
                {popupContent.title}
              </div>
            </div>
            <div
              className={
                "popup_body" +
                (lState.popup.params.loading ? " transparent_layer_wrap" : "")
              }
            >
              {lState.popup.params && lState.popup.params.loading && (
                <div className="transparent_layer" />
              )}

              {lState.popup.params.error && lState.popup.params.error.show && (
                <div className="pcp_error">{lState.popup.params.error.msg}</div>
              )}

              {typeof body === "string" ? (
                <p dangerouslySetInnerHTML={{ __html: body }} />
              ) : lState.popup.alertName === "upgradePlan" ? (
                React.createElement(body, {
                  execute: lState.popup.params.execute,
                  body: lState.popup.params.body,
                  loading: lState.popup.params.loading
                })
              ) : (
                React.createElement(body)
              )}
            </div>
            {popupContent.type &&
              lState.popup.alertName !== "ccUpdateLayout" && (
                <div className="popup_footer">{footer}</div>
              )}
            {lState.popup.alertName === "upgradePlan" && (
              <div className="popup_footer">
                <p className="cp_note">
                  DO NOT click the 'Continue' button more than once or a
                  duplicate order may be placed.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Popup;
